import React from 'react';

type ArrowDirection = 'up' | 'down' | 'left' | 'right' | 'up-left' | 'up-right' | 'down-left' | 'down-right';

interface ArrowProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
    direction?: ArrowDirection;
}

const getRotation = (direction: ArrowDirection): string => {
    switch (direction) {
        case 'up':
            return 'rotate(-90deg)';
        case 'up-right':
            return 'rotate(-45deg)';
        case 'right':
            return 'rotate(0deg)';
        case 'down-right':
            return 'rotate(45deg)';
        case 'down':
            return 'rotate(90deg)';
        case 'down-left':
            return 'rotate(135deg)';
        case 'left':
            return 'rotate(180deg)';
        case 'up-left':
            return 'rotate(-135deg)';
        default:
            return 'rotate(0deg)';
    }
};

export default function Arrow({ color, direction = 'down', ...restProps }: ArrowProps) {
    const rotation = getRotation(direction);

    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: rotation }}
            {...restProps}
        >
            <path
                d="M5.99984 0.666626L5.05984 1.60663L8.77984 5.33329H0.666504V6.66663H8.77984L5.05984 10.3933L5.99984 11.3333L11.3332 5.99996L5.99984 0.666626Z"
                fill={color || '#9196A1'}
            />
        </svg>
    );
}
